import React from 'react';
import CenterSelector from './CenterSelector';
import GlobalSearch from './GlobalSearch';
import NotificationsDropdown from './NotificationsDropdown';

interface TopbarProps {
  username: string;
  onLogout: () => void;
  darkMode: boolean;
  onToggleDarkMode: () => void;
}

const Topbar: React.FC<TopbarProps> = () => {
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm dark:!bg-gray-900 dark:border-gray-700">
      {/* En móvil, padding extra a la izquierda para el botón del menú; buscar expandido solo en md+ */}
      <div className="flex w-full items-center justify-end gap-3 py-3 px-4 pl-12 md:justify-between md:pl-4">
        {/* Búsqueda global desktop */}
        <div className="hidden min-w-0 max-w-md flex-1 items-center md:flex">
          <GlobalSearch />
        </div>

        {/* Right side - Actions */}
        <div className="flex items-center space-x-2 sm:space-x-4">
          {/* Búsqueda global móvil */}
          <GlobalSearch mobileTrigger />

          {/* Center Selector */}
          <CenterSelector />

          {/* Notifications */}
          <NotificationsDropdown />
        </div>
      </div>
    </header>
  );
};

export default Topbar;
